import React, { useMemo, useState } from 'react';
import Icon from './Icon';

const EFFICIENCY = 0.30;

export default function ROICalculator() {
  const [employees, setEmployees] = useState(10);
  const [wage, setWage] = useState(35);
  const [hours, setHours] = useState(8);

  const results = useMemo(() => {
    const weeklyHoursSaved = employees * hours * EFFICIENCY;
    const annualHoursSaved = weeklyHoursSaved * 52;
    const annualSavings = annualHoursSaved * wage;
    return {
      annualHoursSaved: Math.round(annualHoursSaved).toLocaleString(),
      annualSavings: Math.round(annualSavings).toLocaleString(),
      weeklyHoursSaved: Math.round(weeklyHoursSaved),
    };
  }, [employees, wage, hours]);

  return (
    <section id="roi-calculator" className="section">
      <div className="container">
        <div className="section-header reveal">
          <span className="eyebrow">Interactive Tool</span>
          <h2 className="section-title">Estimate Your Automation ROI</h2>
          <p className="section-subtitle">
            Adjust the sliders to see how much time and money automation could save your business.
          </p>
        </div>

        <div className="roi-card reveal">
          <div className="roi-inputs">
            <div className="roi-field">
              <label>Employees affected by manual tasks</label>
              <input
                type="range" min="1" max="200" value={employees}
                onChange={(e) => setEmployees(Number(e.target.value))}
              />
              <span className="roi-value">{employees} employees</span>
            </div>

            <div className="roi-field">
              <label>Average hourly cost per employee</label>
              <input
                type="range" min="15" max="150" value={wage}
                onChange={(e) => setWage(Number(e.target.value))}
              />
              <span className="roi-value">${wage} / hour</span>
            </div>

            <div className="roi-field">
              <label>Hours spent weekly on manual tasks (per employee)</label>
              <input
                type="range" min="1" max="40" value={hours}
                onChange={(e) => setHours(Number(e.target.value))}
              />
              <span className="roi-value">{hours} hrs / week</span>
            </div>
            <p className="roi-note">*Assumes an average 30% efficiency gain from automation.</p>
          </div>

          <div className="roi-results">
            <div className="roi-result-item">
              <Icon name="clock" size={26} />
              <div>
                <strong>{results.weeklyHoursSaved} hrs</strong>
                <span>Reclaimed Weekly</span>
              </div>
            </div>
            <div className="roi-result-item">
              <Icon name="chart-bar" size={26} />
              <div>
                <strong>{results.annualHoursSaved} hrs</strong>
                <span>Reclaimed Annually</span>
              </div>
            </div>
            <div className="roi-result-item highlight">
              <Icon name="dollar-sign" size={26} />
              <div>
                <strong>${results.annualSavings}</strong>
                <span>Estimated Annual Savings</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}